import { InsuranceDto, InsuranceDtoDefault } from '@gtpl/shared-models/masters';
import { Injectable } from '@nestjs/common';
import { InsuranceDTO } from './insurance-dto';
import { Insurance } from './insurance.entity';

@Injectable()
export class InsuranceAdapter {
  
  public convertDtoToEntity(  insuranceDTO: InsuranceDTO,  isUpdate: boolean = false ): Insurance {
    const insurance = new Insurance();
    insurance.insuranceId=insuranceDTO.insuranceId;
    insurance.companyName=insuranceDTO.companyName;
    insurance.insuranceType=insuranceDTO.insuranceType;
    insurance.emailId=insuranceDTO.emailId;
    insurance.mobileNumber=insuranceDTO.mobileNumber;
    insurance.isActive=insuranceDTO.isActive==undefined?true:insuranceDTO.isActive;
    if (isUpdate) {
      insurance.updatedUser = insuranceDTO.updatedUser;
    } else {
      insurance.isActive = true;
      insurance.createdUser = insuranceDTO.createdUser;
    }
   return insurance;
  }
  public convertEntityToDto(insuranceObject: Insurance): InsuranceDTO {
    const insurancesDTO= new InsuranceDTO;
    insurancesDTO.insuranceId = insuranceObject.insuranceId;
    insurancesDTO.companyName = insuranceObject.companyName;
    insurancesDTO.emailId = insuranceObject.emailId;
    insurancesDTO.mobileNumber = insuranceObject.mobileNumber;
    insurancesDTO.insuranceType = insuranceObject.insuranceType;
    insurancesDTO.isActive = insuranceObject.isActive;
    insurancesDTO.createdUser = insuranceObject.createdUser;
    insurancesDTO.updatedUser = insuranceObject.updatedUser;
    insurancesDTO.versionFlag = insuranceObject.versionFlag;
    return insurancesDTO;
  }
}
